import { useNavigate } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import TextField from 'modules/core/components/TextField'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useForm } from 'modules/core/hooks/useForm'
import type { FormErrors } from 'modules/core/hooks/useForm'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'

import { useCreateCategory } from 'modules/trainings/hooks/Categories/useCreateCategory'

interface NewCategoryFormValues {
  name: string
}

const NewCategory = () => {
  const { company } = useCurrentSession()
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const navigateToCategories = () => {
    navigate(navigation.trainings.list.categories.fullPath())
  }
  const { loading: creating, create } = useCreateCategory({
    onCompleted(data) {
      if (data.trainingsMutations.createTrainingsCategory?.errors.length) {
        return
      }

      navigateToCategories()
    },
  })

  const form = useForm<NewCategoryFormValues>({
    defaultValues: {
      name: '',
    },
    validate: (data) => {
      const errors: FormErrors<NewCategoryFormValues> = {}

      if (!data.name) {
        errors.name = i18n.t('common.empty')
      }

      return errors
    },
    onSubmit: async (data) => {
      const result = await create({ ...data, companyId: company.id })

      const handled = handleResult(result, () => {
        // TODO: do something with form errors
      })

      return handled
    },
  })

  return (
    <Modal
      title={i18n.t('trainings.tags.modal.create.title')}
      description={i18n.t('trainings.tags.modal.create.subtitle')}
      onClose={navigateToCategories}
      onSubmit={() => form.handleSubmit()}
      footer={
        <Button disabled={creating || !form.isValid} submit>
          {i18n.t('trainings.tags.modal.create.save_button_label')}
        </Button>
      }
    >
      <TextField
        label={i18n.t('trainings.tags.modal.create.input_label')}
        value={form.values.name}
        onChange={(value: string) => form.setValues({ ...form.values, name: value })}
      />
    </Modal>
  )
}

export default NewCategory
